import { render } from "./InterfaceShortcut.vue?vue&type=template&id=815efb84"
import script from "./InterfaceShortcut.vue?vue&type=script&lang=js"
export * from "./InterfaceShortcut.vue?vue&type=script&lang=js"

import "./InterfaceShortcut.vue?vue&type=style&index=0&id=815efb84&lang=scss"

import exportComponent from "/tmp/6f278242-b890-433a-91e8-ee1cfc12c380/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__